export default "__VITE_ASSET__DfJ$a$lF__"